import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';

export const useGoalsOverviewOnSectionCollapse = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (changedSectionIds: ID[]) =>
      updateSettings({
        filters: {
          goalsOverview: {
            collapsedSections: changedSectionIds,
          },
        },
      }),
    [updateSettings],
  );
};
